import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AmendPage } from '@/features/amend/amend-page';
import { filingQuery } from '@/lib/queries';
import { FormSkeleton } from '@/components/ui/feedback';

export const Route = createFileRoute('/_app/e-files/$efileId_/correct')({
  // The shape this page takes, rather than a search box over a table for
  // every route: the screen must not rearrange itself once the data lands.
  pendingComponent: () => <FormSkeleton fields={4} />,
  // A draft of this amendment, reopened from the Drafts list (TS-8288).
  validateSearch: z.object({ uploadId: z.string().optional() }),
  loader: ({ context, params }) => context.queryClient.ensureQueryData(filingQuery(params.efileId)),
  component: CorrectFilingPage,
});

function CorrectFilingPage() {
  const { efileId: filingId } = Route.useParams();
  const { uploadId } = Route.useSearch();
  return <AmendPage kind="correction" filingId={filingId} resumeUploadId={uploadId} />;
}
